<template>
    <DCard
        :title="__('messages.dashboard.widgets.psa_orders.title') + ' - ' + __('messages.dashboard.widgets.psa_orders.description')"
        class="height widget p-3 card"
    >
        <DRow class="mt-3">
            <DCol
                sm="3"
                class="user-dropdown"
            >
                <DSelect
                    id="status-dropdown"
                    :value="psaOrdersData.selectedContractManager"
                    :options="contractManagerOptions"
                    @update:value="updateSelectedContractManagers"
                />
            </DCol>
        </DRow>
        <CChartBar
            id="psa-bar"
            type="bar"
            :data="psaOrdersData"
            :custom-tooltips="false"
            :options="options"
            class="p-3"
            :height="250"
        />
        <span class="help-text">
            {{ '*' + __('messages.dashboard.widgets.psa_orders.help_text') }}
        </span>
    </DCard>
</template>

<script setup>
import { CChartBar } from '@coreui/vue-chartjs'
import { ref, onMounted } from 'vue'
import { route } from '~@/Composables/route'
import { router } from '@inertiajs/vue3'

const psaOrdersData = ref({})
const contractManagerOptions = ref({})
const labels = ref({})

onMounted(() => {
    const params = {
        widget: 'psa_orders'
    }
    getPsaOrders(params)
})

const options = ref({
    onHover: (event, chartElement) => {
        event.native.target.style.height = '250px'
        event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default'
    },
    onClick: (evt, activeEls, chart) => {
        const status = chart.tooltip.title[0]
        const _query = {}

        labels.value.forEach(item => {
            if (item.translation === status) {
                _query.statuses = [item.type]
            }

            if (psaOrdersData.value.selectedContractManager !== 'all') {
                _query.contractManagers = [psaOrdersData.value.selectedContractManager]
            }
        })
        router.get(route('orders.psa.index', {
            _query
        }))
    },
    maintainAspectRatio: false,
    scales: {
        x: {
            grid: {
                display: false
            }
        },
        y: {
            type: 'logarithmic',
            grid: {
                display: false
            },
            ticks: {
                format: { maximumSignificantDigits: 1 }
            }
        }
    },
    plugins: {
        legend: {
            display: false
        }
    }
})

function buildDataSet (response) {
    return {
        selectedContractManager: response.params.selectedContractManager,
        labels: response.data.labels ? response.data.labels.map(item => item.translation) : [],
        datasets: [
            {
                data: response.data.orders,
                backgroundColor: ['#08aad2', '#fe6e73', '#d63f38', '#69ae34', '#dfb52c', '#f89256', '#7d8998']
            }
        ]
    }
}

function buildManagerOptions (params) {
    return params.contractManagers.map((item) => {
        return { value: item.value, label: item.label }
    })
}

function updateSelectedContractManagers (value) {
    const params = {
        widget: 'psa_orders',
        contract_manager: value
    }
    getPsaOrders(params)
}

function getPsaOrders (params) {
    window.axios.get(route('widgets.get-data'), {
        params: params
    })
        .then(function (response) {
            psaOrdersData.value = buildDataSet(response.data)
            contractManagerOptions.value = buildManagerOptions(response.data.params)
            labels.value = response.data.data.labels
        })
}
</script>

<style scoped>
    .user-dropdown {
        margin-left: 20px;
    }
    .help-text {
        font-size: 12px;
        font-weight: bold;
        padding: 16px 16px 0px 16px;
    }
</style>
